import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class HeaderTextService {

  private titulo: string = '';
  private nombre: string = '';
  private tituloManual: string | null = null;

  getTitulo(): string {
    return this.titulo || '';
  }

  getTituloManual(): string | null {
    return this.tituloManual;
  }

  setTitulo(route: Router, nombre?: string) {
    this.titulo = route.url;
    this.tituloManual = null; 
    if (nombre) {
      this.nombre = nombre;
    }
  }

  setTituloManual(titulo: string): void {
    this.tituloManual = titulo;
  }

  getNombre(): string {
    return this.nombre || '';
  }
}
